import { bootstrapWidget } from "../../common";
import ExplorerWidget from "./widget";
import { LEAFLET_CSS } from "../../common/map";

bootstrapWidget({
  widget: ExplorerWidget,
  widgetType: "explorer",
  // Leaflet rides on top of the resolved base — the old full cssUrls override
  // displaced the SSR page's hashed links with /w/ guesses (#787).
  extraCssUrls: [LEAFLET_CSS],
});
